export default {"src":"/_next/static/media/providus.611ffcab.svg","height":38,"width":78,"blurWidth":0,"blurHeight":0};